import { render, staticRenderFns } from "./FormBiodata.vue?vue&type=template&id=4e50f35a"
import script from "./FormBiodata.vue?vue&type=script&lang=ts"
export * from "./FormBiodata.vue?vue&type=script&lang=ts"
import style0 from "./FormBiodata.vue?vue&type=style&index=0&id=4e50f35a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports